import { ChartPalette } from '../../../../../../../styles/chart-palette';
import Slice from './Slice';
import { pieChartClasses, Svg } from './styles';
import usePieChart, { UsePieChart } from './vm';

export interface PieChartProps extends UsePieChart {
  className?: string;
}

/**
 * @reference https://www.react-graph-gallery.com/pie-plot
 */
const PieChart = ({ className, ...vmProps }: PieChartProps) => {
  const { rootRef, dimensions, pie, radius, isResultVisible } = usePieChart(vmProps);
  const { width, height } = dimensions;

  return (
    <div ref={rootRef} className={className}>
      <Svg width={width} height={height}>
        <g transform={`translate(${width / 2}, ${height / 2})`} className={pieChartClasses.chart}>
          {pie.map((slice, index) => {
            if (slice.data.totalSelections === 0) return null;
            return (
              <Slice
                key={index}
                radius={radius}
                slice={slice}
                color={isResultVisible ? ChartPalette[index] : '#eee'}
                label={slice.data.alphabet}
                tooltip={slice.data.text}
                className={pieChartClasses.slice}
              />
            );
          })}
        </g>
      </Svg>
    </div>
  );
};

export default PieChart;
